var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100" }, props),
    React.createElement("path", { d: "M98 32.1c-.4-.5-1-.8-1.6-.8h-73l-3.8-13.5c-.1-.3-2.1-6.9-7.7-8C7.4 9 4 8.6 3.9 8.6c-1.1-.1-2.1.6-2.2 1.7-.1 1.1.6 2.1 1.7 2.2 0 0 3.4.5 7.8 1.3 3.2.6 4.6 5.1 4.6 5.1l12.1 43.2 2.6 9.3c.4 1.8 2.3 5.1 6.9 5.1h45.1c1.1 0 2-.9 2-2s-.9-2-2-2H37.4c-2.4 0-2.9-1.5-3-2v-.2l-1.9-6.9h54.1c1 0 1.8-.7 2-1.7l9.8-27.9c.1-.5 0-1.2-.4-1.7zM85.1 59.5H31.3l-6.8-24.3h69l-8.4 24.3zM41.6 78.4c-3.6 0-6.5 2.9-6.5 6.5s2.9 6.5 6.5 6.5 6.5-2.9 6.5-6.5-2.9-6.5-6.5-6.5zm0 9.1c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5zm33.8-9.1c-3.6 0-6.5 2.9-6.5 6.5s2.9 6.5 6.5 6.5 6.5-2.9 6.5-6.5-2.9-6.5-6.5-6.5zm0 9.1c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5z" })
  );
});


// WEBPACK FOOTER //
// ../public/images/icons/cart.svg?react-svg